export default "__VITE_ASSET__BAqUntu___"